import { useCallback, useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { api, formatRupiah } from "@/lib/api";

const POLL_MS = 15000;

function chime() {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    [0, 0.18].forEach((t, i) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "sine";
      osc.frequency.value = i === 0 ? 880 : 1174;
      gain.gain.setValueAtTime(0.0001, ctx.currentTime + t);
      gain.gain.exponentialRampToValueAtTime(0.2, ctx.currentTime + t + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + t + 0.35);
      osc.connect(gain).connect(ctx.destination);
      osc.start(ctx.currentTime + t);
      osc.stop(ctx.currentTime + t + 0.4);
    });
  } catch {
    /* audio blocked by browser policy */
  }
}

export function useNewOrders(enabled) {
  const [unseen, setUnseen] = useState(0);
  const [pendingPayments, setPendingPayments] = useState(0);
  const prev = useRef(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/orders/unseen");
      setUnseen(data.count);
      setPendingPayments(data.pending_payments || 0);
      if (prev.current !== null && data.count > prev.current && data.latest) {
        chime();
        toast.success(
          `Pesanan baru ${data.latest.order_code} dari ${data.latest.buyer_name} — ${formatRupiah(data.latest.total)}`,
          { duration: 8000 }
        );
      }
      prev.current = data.count;
    } catch {
      /* ignore polling errors */
    }
  }, []);

  const markSeen = useCallback(async () => {
    await api.post("/orders/mark-seen").catch(() => {});
    prev.current = 0;
    setUnseen(0);
  }, []);

  useEffect(() => {
    if (!enabled) return undefined;
    refresh();
    const id = setInterval(refresh, POLL_MS);
    return () => clearInterval(id);
  }, [enabled, refresh]);

  return { unseen, pendingPayments, refresh, markSeen };
}
